import { FunctionComponent } from "react";
import { useAppSelector } from "@store/store";
import { selectSelectedEntity } from "@store/map/mapReducer";
import { PlanMarker } from "../elements/PlanMarker";
import { PlanItem } from "@dto/PlanItem";
import { Place } from "@dto/Place";

export const EntityChildrenMarkers: FunctionComponent = () => {
  const selectedEntity = useAppSelector(selectSelectedEntity);

  if (!selectedEntity?.entity || !("planItems" in selectedEntity.entity)) {
    return null;
  }

  const planItems = (selectedEntity.entity as { planItems: PlanItem[] })
    .planItems;

  return (
    <>
      {planItems.map((planItem, index) => {
        if (!planItem.plannable || !("location" in planItem.plannable)) {
          return null;
        }

        const plannable = planItem.plannable as Place;
        if (!plannable.location) {
          return null;
        }

        return (
          <PlanMarker
            key={planItem.id}
            coordinates={{
              latitude: plannable.location.latitude,
              longitude: plannable.location.longitude,
            }}
            ordinal={index + 1}
            zIndex={1000 + index}
          />
        );
      })}
    </>
  );
};
